import { Link } from 'react-router-dom';
import logoWhite from 'src/assets/images/logo/logo_white.svg';

type Props = {
  className?: string;
  onClick?: () => void;
};

export function BrightSaaSLogo({ className, onClick }: Props) {
  const cls = ['nk-logo', 'align-items-center', className]
    .filter(Boolean)
    .join(' ');
  return (
    <Link className={cls} to="/" onClick={onClick} style={{ opacity: 0.9 }}>
      <img
        src={logoWhite}
        alt="Yapamar logo"
        style={{ height: 20, width: 'auto', maxHeight: 20, marginRight: 8 }}
      />
      <span
        className="fw-medium text-white"
        style={{ fontSize: '1.2em', lineHeight: 1 }}>
        YAPAMAR
      </span>
    </Link>
  );
}
